import { mergeClasses } from '@blank/utilities'
import {
  Button,
  ButtonBaseProps,
  ButtonDesignOptionProps,
} from '../Button/Button'

export type DropdownMenuItemProps = ButtonBaseProps &
  Partial<ButtonDesignOptionProps>
export const DropdownMenuItem = ({
  children,
  className,
  ref: _,
  variant = 'none',
  color = undefined,
  ...props
}: DropdownMenuItemProps) => {
  return (
    <Button
      variant={variant}
      color={color}
      {...props}
      className={mergeClasses(
        'flex w-full justify-start px-2 py-4 font-bold',
        className
      )}
    >
      {children}
    </Button>
  )
}
